import { SubitemKind } from '@/types/PolicySublimit';
import { SubitemType, SubitemTypeSaveRequest } from '@/types/SubitemType';
import { Service } from './api';

class SubitemTypeService extends Service {
  async list(kind: SubitemKind): Promise<SubitemType[]> {
    return this.handleRequest(this.get<SubitemType[]>(this.path(kind)));
  }

  async create(kind: SubitemKind, request: SubitemTypeSaveRequest): Promise<SubitemType> {
    return this.handleRequest(this.post<SubitemType>(this.path(kind), request));
  }

  async update(kind: SubitemKind, id: number, request: SubitemTypeSaveRequest): Promise<void> {
    await this.handleRequest(this.put<void>(`${this.path(kind)}/${id}`, request));
  }

  async remove(kind: SubitemKind, id: number): Promise<void> {
    await this.handleRequest(this.delete<void>(`${this.path(kind)}/${id}`));
  }

  private path(kind: SubitemKind): string {
    return `/v1/admin/${kind}-types`;
  }
}

export const subitemTypeService = new SubitemTypeService();
